module.exports = __webpack_public_path__ + "dab7611ab97a246e2cb7a4dc1934f056.png";